export default class Equipment {
  public row_number: number | undefined;
  //private _isRowOpen: boolean = false;
  public type: string | undefined;
  public serialNumber: string | undefined;
  public make: string | undefined;
  public model: string | undefined;
  public year: string | undefined;
}
